export const FIELD_MESSAGES = {
  NODE_NOT_READY: 'Node is not ready yet.',
  NODE_TYPE_NOT_READY: 'Node type is not ready yet.',
  TYPE_DEFINITION_NOT_READY: 'Type definition is not ready yet.',
  NODE_OR_TYPE_NOT_READY: 'Node or type is not ready yet.',
  CREATE_ROW_BEFORE_ADD: 'Create a row before adding fields.',
  ADD_FAILED: 'Failed to add field.',
  UPDATE_FAILED: 'Failed to update field.',
  DELETE_FAILED: 'Failed to delete field.',
  REORDER_FAILED: 'Failed to reorder fields.',
};

export const FIELD_LOG_MESSAGES = {
  ADD_FIELD_FAILED: 'Add field failed:',
  UPDATE_FIELD_FAILED: 'Update field failed:',
  DELETE_FIELD_FAILED: 'Delete field failed:',
  REORDER_FIELDS_FAILED: 'Reorder failed:',
  TABLE_ADD_FIELD_FAILED: '[TableView] add field error:',
};
